import { Alert, Button } from "antd";
import { I18N_NS } from "Config/i18n";
import { withTranslation } from "react-i18next";
import { Loader } from "./Loader";
import loadable from "@loadable/component";

let RELOAD_COUNTER = 0;
// TODO: add typings
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LoadingComponent = withTranslation(I18N_NS.GENERAL)(({ pastDelay, error, retry, timedOut, t }: any) => {
  const retryAndReload = () => {
    retry();
    ++RELOAD_COUNTER;
    if (RELOAD_COUNTER >= 1) {
      document.location.reload();
    }
  };

  // When the loader has errored
  if (error) {
    ++RELOAD_COUNTER;
    // tslint:disable-next-line:no-console
    console.error(error);
    return (
      <div style={{ maxWidth: 600, margin: "10px auto" }}>
        <Alert
          type="warning"
          title={
            <div>
              {t(
                `It seems that a newer PMG software version got available while you were logged in. Please press the button "Reload user interface". If after this you still cannot continue working, please try to log out and back in again.`
              )}
              <div style={{ textAlign: "center", marginTop: 10 }}>
                <Button type="primary" onClick={retryAndReload}>
                  {t("Reload user interface")}
                </Button>
              </div>
            </div>
          }
        />
      </div>
    );
  } else if (timedOut) {
    return (
      <Alert
        type="info"
        title={
          <div>
            {t("Taking a long time...")}
            <Button style={{ marginLeft: 10 }} type="primary" onClick={retryAndReload}>
              {t("Reload user interface")}
            </Button>
          </div>
        }
      />
    );
  } else if (pastDelay) {
    // When the loader has taken longer than the delay
    return <Loader />;
  } else {
    // When the loader has just started
    return null;
  }
});

export const LoadAsync = (loader) => loadable(loader, { fallback: <LoadingComponent /> });
